import { render, staticRenderFns } from "./CreateContinuarAssistindo.vue?vue&type=template&id=4dca13de&"
import script from "./CreateContinuarAssistindo.vue?vue&type=script&lang=js&"
export * from "./CreateContinuarAssistindo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports